export const getLaneIndex = (board, status) => board.lanes.findIndex(l => l.id === status)

export const getPaginatedBoardIndex = (board, laneIndex, proposalId) =>
  board.lanes[laneIndex].cards.findIndex(p => +p.id === +proposalId)

export const getPaginatedBopardUnfilteredIndex = (board, laneIndex, proposalId) =>
  board.lanes[laneIndex].unfilteredCards.findIndex(p => +p.id === +proposalId)
